import { render, staticRenderFns } from "./ClicLink.vue?vue&type=template&id=711a5dc4&"
import script from "./ClicLink.vue?vue&type=script&lang=js&"
export * from "./ClicLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports